export default "https://cdn-static.gokick.com/assets/9232f824e6a46c896411df64bf74cb68df4bd809/images/tangerine-flavor.1fe86552bc4a40407da21340599dcac8.png";